import router from "@/router"
import Vue3Resize from "vue3-resize"
import "vue3-resize/dist/vue3-resize.css"
import { createApp } from "vue"
import App from "./App.vue"
import "@css/common.css"
import "@css/flex.css"
import "@css/display-helper.css"
import "@css/responsive.css"
import { createPinia } from "pinia"
import EcFormBox from "@/components/EcFormBox.vue"
import EcFormItem from "@/components/EcFormItem.vue"
import EcEditableLabel from "@/components/EcEditableLabel.vue"
import EcIcon from "@/components/EcIcon.vue"
import EcSearchFilter from "@/components/EcSearchFilter.vue"
import EcSearchInput from "@/components/EcSearchInput.vue"
import EcButton from "@/components/EcButton.vue"
import EcHighlightLabel from "@/components/EcHighlightLabel.vue"
import EcFlex from "./components/EcFlex.vue"

import {
  // create naive ui
  create,
  // component
  NButton,
  NSpace,
  NLayout,
  NLayoutContent,
  NLayoutFooter,
  NLayoutHeader,
  NLayoutSider,
  NMenu,
  NTabs,
  NTabPane,
  NList,
  NListItem,
  NAvatar,
  NDropdown,
  NGrid,
  NGridItem,
  NIcon,
  NText,
  NH1,
  NH2,
  NH3,
  NH4,
  NH5,
  NH6,
  NSpin,
  NUl,
  NLi,
  NOl,
  NP,
  NForm,
  NFormItem,
  NResult,
  NCard,
  NInput,
  NInputGroup,
  NSwitch,
  NRadio,
  NRadioButton,
  NRadioGroup,
  NInputNumber,
  NSelect,
  NModal,
  NCheckboxGroup,
  NCheckbox,
  NTreeSelect,
  NPopover,
  NConfigProvider,
  NDivider,
  NDrawer,
  NDrawerContent,
  NSteps,
  NStep,
  NDataTable,
  NTag,
  NTree,
  NProgress,
  NCarousel,
  NImage,
  NBreadcrumb,
  NBreadcrumbItem,
  NDatePicker,
  NTimePicker,
  NAffix,
  NSlider,
  NPagination,
  NPopselect,
  NTooltip,
  NPopconfirm,
  NMessageProvider,
  NDialogProvider,
  NSkeleton,
  NCountdown,
  NBackTop,
  NCollapse,
  NCollapseItem,
} from "naive-ui"

const naive = create({
  components: [
    NButton,
    NSpace,
    NLayout,
    NLayoutContent,
    NLayoutFooter,
    NLayoutHeader,
    NLayoutSider,
    NMenu,
    NTabs,
    NTabPane,
    NList,
    NListItem,
    NAvatar,
    NDropdown,
    NGrid,
    NGridItem,
    NIcon,
    NText,
    NH1,
    NH2,
    NH3,
    NH4,
    NH5,
    NH6,
    NSpin,
    NUl,
    NLi,
    NOl,
    NP,
    NForm,
    NFormItem,
    NResult,
    NCard,
    NInput,
    NInputGroup,
    NSwitch,
    NRadio,
    NRadioButton,
    NRadioGroup,
    NInputNumber,
    NSelect,
    NModal,
    NCheckboxGroup,
    NCheckbox,
    NTreeSelect,
    NPopover,
    NConfigProvider,
    NDivider,
    NDrawer,
    NDrawerContent,
    NSteps,
    NStep,
    NDataTable,
    NTag,
    NTree,
    NProgress,
    NCarousel,
    NImage,
    NBreadcrumb,
    NBreadcrumbItem,
    NDatePicker,
    NTimePicker,
    NAffix,
    NSlider,
    NPagination,
    NPopselect,
    NTooltip,
    NPopconfirm,
    NMessageProvider,
    NDialogProvider,
    NSkeleton,
    NCountdown,
    NBackTop,
    NCollapse,
    NCollapseItem,
  ],
})

const pinia = createPinia()
const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(naive)
app.use(Vue3Resize)
app
  .component("EcFormBox", EcFormBox)
  .component("EcFormItem", EcFormItem)
  .component("EcEditableLabel", EcEditableLabel)
  .component("EcIcon", EcIcon)
  .component("EcSearchFilter", EcSearchFilter)
  .component("EcSearchInput", EcSearchInput)
  .component("EcButton", EcButton)
  .component("EcHighlightLabel", EcHighlightLabel)
  .component("EcFlex", EcFlex)

app.mount("#app")
